import _asyncToGenerator from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import QueryParamsProxy from '../../../utils/queryParamProxy';
import RouteParamConstants from '../../../utils/routeParamConstants';
import Screens from '../../index';
import { setPurchaseType } from '../../../state/actions/prePurchase';
import { setNavState } from '../../../state/actions/nav_state';
import navigation from '../../../utils/navigation/navigation';
import Logger from '../../../lib/analytics/logger';
import ERROR_CODE from '../../../utils/errorCodes';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import audio from '../../../utils/audio';
import { PURCHASE_RESPONSE, PURCHASE_TYPE, REG_EXP } from '../../../constants';
import { usePostOfferDetailMutation, usePostPurchaseOfferMutation } from '../../../state/query/rewardCenter';
import { useLazyGetAppEventsUpdateQuery } from '../../../state/query/app';
import NavigationConstants from '../../../components/LobbyOverlay/NavigationConstants';
import useNotification from '../../../hooks/useNotification';
import { getText, TEXT_KEY } from '../../../utils/localization';
import { ServerResponseKeys } from '../../../api/Constants';
import { hasObjectValues } from '../../../utils/object';
import { handleNewActiveGameRoom } from '../../Home/utils/helper';
import { sendRewardCenterEvent } from '../analytics/rewardCenterlogger';
import { REWARD_CENTER_EVENT_TYPES } from '../constants';
import store from '../../../state/store';
import { getOfferInsufficientBalanceMessage, getOfferPriceValue, hasSufficientOfferBalance, isCoinOffer } from '../utils/validations';
var REDEEM_ATTEMPT_STATUS = {
  BLOCKED: 'blocked',
  SUBMITTED: 'submitted'
};
var REDEEM_RESULT_STATUS = {
  FAILURE: 'failure',
  SUCCESS: 'success'
};
var useRewardCenterOfferDetails = function useRewardCenterOfferDetails(_ref) {
  var activeOffer = _ref.selectedOffer,
    purchaseResponse = _ref.purchaseResponse,
    setPurchaseResponse = _ref.setPurchaseResponse,
    RewardsImageBaseURL = _ref.RewardsImageBaseURL,
    setSelectedOffer = _ref.setSelectedOffer,
    postRewardCenter = _ref.postRewardCenter,
    postRewardCenterDisplayed = _ref.postRewardCenterDisplayed,
    clearFilterData = _ref.clearFilterData;
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    offerDetails = _useState2[0],
    setOfferDetails = _useState2[1];
  var _usePostPurchaseOffer = usePostPurchaseOfferMutation(),
    _usePostPurchaseOffer2 = _slicedToArray(_usePostPurchaseOffer, 1),
    postPurchaseOffer = _usePostPurchaseOffer2[0];
  var _usePostOfferDetailMu = usePostOfferDetailMutation(),
    _usePostOfferDetailMu2 = _slicedToArray(_usePostOfferDetailMu, 1),
    postOfferDetail = _usePostOfferDetailMu2[0];
  var _useLazyGetAppEventsU = useLazyGetAppEventsUpdateQuery(),
    _useLazyGetAppEventsU2 = _slicedToArray(_useLazyGetAppEventsU, 1),
    getUpdateAppEvents = _useLazyGetAppEventsU2[0];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    property = _useState4[0],
    setProperty = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isVipPurchase = _useState6[0],
    setIsVipPurchase = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isPurchaseButtonDisabled = _useState10[0],
    setIsPurchaseButtonDisabled = _useState10[1];
  var lastViewedOfferIdRef = useRef(null);
  var _useNotification = useNotification(),
    addNotification = _useNotification.addNotification;
  var _useSelector = useSelector(function (state) {
      return {
        playerInfo: state.playerInfo,
        unlimitedVipAccess: state.consumables.unlimitedVipAccess,
        coin: state.coin,
        loyalty: state.loyalty
      };
    }, shallowEqual),
    isAccountLinked = _useSelector.playerInfo.isAccountLinked,
    unlimitedVipAccess = _useSelector.unlimitedVipAccess,
    coin = _useSelector.coin,
    loyalty = _useSelector.loyalty;
  var hasResolvedOfferDetails = (offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.offerId) === (activeOffer === null || activeOffer === void 0 ? void 0 : activeOffer.offerId);
  var resolvedOfferDetails = useMemo(function () {
    return hasResolvedOfferDetails ? _objectSpread(_objectSpread({}, activeOffer), offerDetails) : activeOffer;
  }, [activeOffer, hasResolvedOfferDetails, offerDetails]);
  var _ref2 = resolvedOfferDetails || {},
    terms = _ref2.terms,
    rewardtype = _ref2.rewardtype,
    rewardType = _ref2.rewardType,
    properties = _ref2.properties;
  var resolvedRewardType = rewardType || rewardtype;
  var vipPurchaseUnlimitedAccess = resolvedRewardType === PURCHASE_TYPE.VIP_ROOM_ACCESS && unlimitedVipAccess;
  var isCoinPricing = isCoinOffer(resolvedOfferDetails);
  var insufficientOfferBalance = !hasSufficientOfferBalance(resolvedOfferDetails, {
    coinBalance: coin === null || coin === void 0 ? void 0 : coin.value,
    loyaltyBalance: loyalty === null || loyalty === void 0 ? void 0 : loyalty.value
  });
  var hasInsufficientBalance = insufficientOfferBalance;
  var termsByRegex = terms && terms.split(REG_EXP.https);
  var _ref3 = termsByRegex || [],
    _ref4 = _slicedToArray(_ref3, 2),
    termsText = _ref4[0],
    termsUrl = _ref4[1];
  var propertyList = useMemo(function () {
    return properties ? Object.values(properties).map(function (item) {
      return {
        label: item.property_name,
        value: item.property_id
      };
    }) : null;
  }, [properties]);
  var selectedPropertyId = propertyList ? property : null;
  var selectedPropertyName = useMemo(function () {
    var _propertyList$find$la, _propertyList$find;
    return (_propertyList$find$la = propertyList === null || propertyList === void 0 || (_propertyList$find = propertyList.find(function (item) {
      return "".concat(item.value) === "".concat(selectedPropertyId);
    })) === null || _propertyList$find === void 0 ? void 0 : _propertyList$find.label) !== null && _propertyList$find$la !== void 0 ? _propertyList$find$la : null;
  }, [propertyList, selectedPropertyId]);
  var getCoinBalanceValue = function getCoinBalanceValue() {
    var _store$getState$coin;
    var numericBalance = Number((_store$getState$coin = store.getState().coin) === null || _store$getState$coin === void 0 ? void 0 : _store$getState$coin.value);
    return Number.isFinite(numericBalance) ? numericBalance : null;
  };
  var sendCoinRedeemAnalytics = function sendCoinRedeemAnalytics(_ref5) {
    var eventType = _ref5.eventType,
      _ref5$offer = _ref5.offer,
      offer = _ref5$offer === void 0 ? resolvedOfferDetails : _ref5$offer,
      playerCoinBalanceBefore = _ref5.playerCoinBalanceBefore,
      playerCoinBalanceAfter = _ref5.playerCoinBalanceAfter,
      attemptStatus = _ref5.attemptStatus,
      resultStatus = _ref5.resultStatus,
      failureReason = _ref5.failureReason;
    if (!isCoinOffer(offer)) return;
    sendRewardCenterEvent(eventType, {
      offer: offer,
      propertyId: selectedPropertyId,
      propertyName: selectedPropertyName,
      playerCoinBalanceBefore: playerCoinBalanceBefore,
      playerCoinBalanceAfter: playerCoinBalanceAfter,
      attemptStatus: attemptStatus,
      resultStatus: resultStatus,
      failureReason: failureReason
    });
  };
  var getPurchaseFailureReason = function getPurchaseFailureReason() {
    var _error$data;
    var purchaseResponseValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (purchaseResponseValue !== null && purchaseResponseValue !== void 0 && purchaseResponseValue.error) return purchaseResponseValue.error;
    if (purchaseResponseValue !== null && purchaseResponseValue !== void 0 && purchaseResponseValue.msg) return purchaseResponseValue.msg;
    if (purchaseResponseValue !== null && purchaseResponseValue !== void 0 && purchaseResponseValue.message) return purchaseResponseValue.message;
    if (error !== null && error !== void 0 && (_error$data = error.data) !== null && _error$data !== void 0 && _error$data.error) return error.data.error;
    if ((error === null || error === void 0 ? void 0 : error.status) === 'TIMEOUT_ERROR') return 'timeout';
    if ((error === null || error === void 0 ? void 0 : error.status) === 'FETCH_ERROR') return 'request_error';
    if (error !== null && error !== void 0 && error.error) return error.error;
    return 'unknown_error';
  };
  var sendBlockedCoinRedeemAnalytics = function sendBlockedCoinRedeemAnalytics(failureReason) {
    var playerCoinBalanceBefore = getCoinBalanceValue();
    sendCoinRedeemAnalytics({
      eventType: REWARD_CENTER_EVENT_TYPES.RC_REDEEM_ATTEMPTED,
      playerCoinBalanceBefore: playerCoinBalanceBefore,
      playerCoinBalanceAfter: playerCoinBalanceBefore,
      attemptStatus: REDEEM_ATTEMPT_STATUS.BLOCKED,
      resultStatus: REDEEM_RESULT_STATUS.FAILURE,
      failureReason: failureReason
    });
    sendCoinRedeemAnalytics({
      eventType: REWARD_CENTER_EVENT_TYPES.RC_REDEEM_FAILED,
      playerCoinBalanceBefore: playerCoinBalanceBefore,
      playerCoinBalanceAfter: playerCoinBalanceBefore,
      attemptStatus: REDEEM_ATTEMPT_STATUS.BLOCKED,
      resultStatus: REDEEM_RESULT_STATUS.FAILURE,
      failureReason: failureReason
    });
  };
  useEffect(function () {
    if (!(activeOffer !== null && activeOffer !== void 0 && activeOffer.offerId)) lastViewedOfferIdRef.current = null;
    getRewardDetails();
    return function () {
      getUpdateAppEvents({
        forceRefetch: true
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOffer === null || activeOffer === void 0 ? void 0 : activeOffer.offerId, purchaseResponse]);
  var handlePurchase = function handlePurchase() {
    setIsPurchaseButtonDisabled(true);
    onPurchase(propertyList ? property : activeOffer.offerId);
  };
  var checkSelectedProperty = useCallback(function (selectedProperty) {
    if (!property) changeOfferProperty(selectedProperty);
  }, [property]);
  var changeOfferProperty = function changeOfferProperty(selectedProperty) {
    return selectedProperty && setProperty(selectedProperty);
  };
  var handleDefaultPurchase = function handleDefaultPurchase(propertyId) {
    var playerCoinBalanceBefore = getCoinBalanceValue();
    sendCoinRedeemAnalytics({
      eventType: REWARD_CENTER_EVENT_TYPES.RC_REDEEM_ATTEMPTED,
      playerCoinBalanceBefore: playerCoinBalanceBefore,
      playerCoinBalanceAfter: playerCoinBalanceBefore,
      attemptStatus: REDEEM_ATTEMPT_STATUS.SUBMITTED
    });
    purchaseReward(propertyId, playerCoinBalanceBefore);
    if (resolvedRewardType === PURCHASE_TYPE.VIP_ROOM_ACCESS) {
      setIsVipPurchase(true);
      dispatch(setPurchaseType(resolvedRewardType));
    } else dispatch(setPurchaseType(''));
  };
  var onPurchase = debounce( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(propertyId) {
      var shouldShowLinkAccountPopUp;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            shouldShowLinkAccountPopUp = propertyList && isAccountLinked === 'no';
            if (!shouldShowLinkAccountPopUp) {
              _context.next = 6;
              break;
            }
            sendBlockedCoinRedeemAnalytics('account_not_linked');
            QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.LinkAccountForm));
            setIsPurchaseButtonDisabled(false);
            return _context.abrupt("return");
          case 6:
            audio.onClick();
            handleDefaultPurchase(propertyId);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref6.apply(this, arguments);
    };
  }(), 1500, {
    leading: true,
    trailing: false
  });
  var onDismissPurchaseResponse = function onDismissPurchaseResponse() {
    audio.onClick();
    setPurchaseResponse(null);
    setIsPurchaseButtonDisabled(false);
    setSelectedOffer(null);
    clearFilterData();
  };
  var onVipOfferPlayButton = function onVipOfferPlayButton() {
    onDismissPurchaseResponse();
    handleNewActiveGameRoom(navigation, Screens.VIP);
    dispatch(setNavState(NavigationConstants.NO_HIDE));
  };
  var sendOfferRedeemedEvent = function sendOfferRedeemedEvent(offerInfo) {
    var playerCoinBalanceBefore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var amount = offerInfo.amount,
      r_id = offerInfo.r_id,
      offerId = offerInfo.offerId,
      rewardname = offerInfo.rewardname,
      rewardName = offerInfo.rewardName,
      rewardtype = offerInfo.rewardtype,
      rewardType = offerInfo.rewardType,
      propertyId = offerInfo.propertyId;
    var priceValue = getOfferPriceValue(offerInfo);
    var eventPayload = {
      name: rewardname || rewardName,
      id: r_id || offerId,
      reward_type: rewardtype || rewardType,
      prop_id: propertyId
    };
    if (isCoinOffer(offerInfo)) {
      eventPayload.coins = priceValue.toString();
      var balanceBefore = Number.isFinite(playerCoinBalanceBefore) ? playerCoinBalanceBefore : parseInt(coin.value) + parseInt(priceValue);
      eventPayload.balance_before = balanceBefore.toString();
    } else {
      // Loyalty redemption: spend loyalty pts, may receive coins as reward (`amount`).
      eventPayload.loyalty_points_before = (parseInt(loyalty.value) + parseInt(priceValue)).toString();
      eventPayload.loyalty_points = priceValue.toString();
      eventPayload.coins = amount;
      eventPayload.balance_before = (parseInt(coin.value) - parseInt(amount)).toString();
    }
    Logger.sendEvent(EVENT_TYPES.OFFER_REDEEMED, eventPayload);
  };
  var purchaseReward = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(propertyId) {
      var playerCoinBalanceBefore,
        postPurchaseOfferResponse,
        _purchaseResponse,
        hasAction,
        playerCoinBalanceAfter,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            playerCoinBalanceBefore = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
            _context2.prev = 1;
            _context2.next = 4;
            return postPurchaseOffer({
              rid: activeOffer.offerId,
              propertyId: propertyId
            }).unwrap();
          case 4:
            postPurchaseOfferResponse = _context2.sent;
            _purchaseResponse = postPurchaseOfferResponse[ServerResponseKeys.CALL_RESPONSE] || {};
            hasAction = postPurchaseOfferResponse[ServerResponseKeys.ACTIONS_COMANDS] && hasObjectValues(postPurchaseOfferResponse[ServerResponseKeys.ACTIONS_COMANDS]);
            playerCoinBalanceAfter = getCoinBalanceValue();
            if (_purchaseResponse.success) {
              sendOfferRedeemedEvent(_objectSpread(_objectSpread({}, resolvedOfferDetails), {}, {
                propertyId: propertyId
              }), playerCoinBalanceBefore);
              sendCoinRedeemAnalytics({
                eventType: REWARD_CENTER_EVENT_TYPES.RC_REDEEM_SUCCESS,
                playerCoinBalanceBefore: playerCoinBalanceBefore,
                playerCoinBalanceAfter: playerCoinBalanceAfter,
                attemptStatus: REDEEM_ATTEMPT_STATUS.SUBMITTED,
                resultStatus: REDEEM_RESULT_STATUS.SUCCESS
              });
            } else {
              sendCoinRedeemAnalytics({
                eventType: REWARD_CENTER_EVENT_TYPES.RC_REDEEM_FAILED,
                playerCoinBalanceBefore: playerCoinBalanceBefore,
                playerCoinBalanceAfter: playerCoinBalanceAfter,
                attemptStatus: REDEEM_ATTEMPT_STATUS.SUBMITTED,
                resultStatus: REDEEM_RESULT_STATUS.FAILURE,
                failureReason: getPurchaseFailureReason(_purchaseResponse)
              });
            }
            setPurchaseResponse({
              status: _purchaseResponse.success ? PURCHASE_RESPONSE.SUCCESS : PURCHASE_RESPONSE.ERROR,
              message: _purchaseResponse.msg || _purchaseResponse.message
            });
            if (!_purchaseResponse.success && !hasAction) {
              addNotification({
                message: _purchaseResponse.error,
                title: getText(TEXT_KEY.OOPS),
                button: getText(TEXT_KEY.OK),
                buttonAction: function buttonAction() {
                  onDismissPurchaseResponse();
                },
                hideCloseButton: true,
                hideHelpButton: true
              });
            } else {
              setIsPurchaseButtonDisabled(false);
            }
            _context2.next = 13;
            return postRewardCenter({
              requestAssetsData: false
            });
          case 13:
            _context2.next = 15;
            return postRewardCenterDisplayed();
          case 15:
            _context2.next = 22;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](1);
            setIsPurchaseButtonDisabled(false);
            sendCoinRedeemAnalytics({
              eventType: REWARD_CENTER_EVENT_TYPES.RC_REDEEM_FAILED,
              playerCoinBalanceBefore: playerCoinBalanceBefore,
              playerCoinBalanceAfter: playerCoinBalanceBefore,
              attemptStatus: REDEEM_ATTEMPT_STATUS.SUBMITTED,
              resultStatus: REDEEM_RESULT_STATUS.FAILURE,
              failureReason: getPurchaseFailureReason(null, _context2.t0)
            });
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              body: JSON.stringify(_context2.t0),
              code: ERROR_CODE.PURCHASE_OFFER_REQUEST_ERROR
            });
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 17]]);
    }));
    return function purchaseReward(_x2) {
      return _ref7.apply(this, arguments);
    };
  }();
  var getRewardDetails = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var rewardDetailsResponse, resolvedRewardDetails, resolvedOfferView;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (activeOffer !== null && activeOffer !== void 0 && activeOffer.offerId) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            audio.onClick();
            _context3.prev = 3;
            setIsLoading(true);
            _context3.next = 7;
            return postOfferDetail({
              offerId: activeOffer.offerId,
              rewardCenterBaseUrl: RewardsImageBaseURL
            }).unwrap();
          case 7:
            rewardDetailsResponse = _context3.sent;
            if (!rewardDetailsResponse.success) {
              _context3.next = 16;
              break;
            }
            resolvedRewardDetails = rewardDetailsResponse === null || rewardDetailsResponse === void 0 ? void 0 : rewardDetailsResponse.offerDetails;
            resolvedOfferView = _objectSpread(_objectSpread({}, activeOffer), resolvedRewardDetails);
            setOfferDetails(resolvedRewardDetails);
            setIsLoading(false);
            if (lastViewedOfferIdRef.current !== activeOffer.offerId) {
              sendCoinRedeemAnalytics({
                eventType: REWARD_CENTER_EVENT_TYPES.RC_REDEEM_OFFER_VIEWED,
                offer: resolvedOfferView
              });
              lastViewedOfferIdRef.current = activeOffer.offerId;
            }
            _context3.next = 17;
            break;
          case 16:
            throw new Error(rewardDetailsResponse.error);
          case 17:
            _context3.next = 23;
            break;
          case 19:
            _context3.prev = 19;
            _context3.t0 = _context3["catch"](3);
            setIsLoading(false);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              body: JSON.stringify(_context3.t0),
              code: ERROR_CODE.GET_REWARD_DETAILS_REQUEST_ERROR
            });
          case 23:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[3, 19]]);
    }));
    return function getRewardDetails() {
      return _ref8.apply(this, arguments);
    };
  }();
  var disabledButtonClick = function disabledButtonClick() {
    if (hasInsufficientBalance) {
      sendBlockedCoinRedeemAnalytics(isCoinPricing ? 'insufficient_coins' : 'insufficient_loyalty');
      return;
    }
    if (vipPurchaseUnlimitedAccess) {
      sendBlockedCoinRedeemAnalytics('unlimited_vip_access');
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.VipAccessFlow));
    }
  };
  useEffect(function () {
    var _propertyList$;
    if (propertyList) checkSelectedProperty((_propertyList$ = propertyList[0]) === null || _propertyList$ === void 0 ? void 0 : _propertyList$.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyList]);
  return {
    handlePurchase: handlePurchase,
    onDismissPurchaseResponse: onDismissPurchaseResponse,
    purchaseResponse: purchaseResponse,
    isLoading: isLoading || !hasResolvedOfferDetails,
    isVipPurchase: isVipPurchase,
    onDisabledButtonClick: disabledButtonClick,
    offerDetails: resolvedOfferDetails,
    terms: terms,
    termsText: termsText,
    termsUrl: termsUrl,
    isPurchaseButtonDisabled: vipPurchaseUnlimitedAccess || hasInsufficientBalance || isPurchaseButtonDisabled,
    setIsPurchaseButtonDisabled: setIsPurchaseButtonDisabled,
    onVipOfferPlayButton: onVipOfferPlayButton,
    isCoinOffer: isCoinPricing,
    priceValue: getOfferPriceValue(resolvedOfferDetails),
    insufficientBalanceMessage: hasInsufficientBalance ? getOfferInsufficientBalanceMessage(resolvedOfferDetails) : null
  };
};
export default useRewardCenterOfferDetails;